import * as ACTION from './constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function*() {
    yield takeLatest(ACTION.UNLINK_ORDER.REQUEST, saga.unlinkOrder);
    yield takeLatest(ACTION.UNLINK_ORDER.SUCCESS, saga.unlinkOrderSuccess);
    yield takeLatest(ACTION.UNLINK_ORDER.FAILED, saga.unlinkOrderFailed);
}
